"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Colours = _interopRequireWildcard(require("@/helpers/Colours"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var _default = {
  props: ['ircinput'],
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    var boldButton = document.getElementById('bold');
    if (this.$state.setting('boldFont')) {
      boldButton.style.fontWeight = 'bold';
    } else {
      boldButton.style.fontWeight = 'normal';
    }
    var italicButton = document.getElementById('italic');
    if (this.$state.setting('italicFont')) {
      italicButton.style.fontWeight = 'bold';
    } else {
      italicButton.style.fontWeight = 'normal';
    }
  },
  methods: {
    onColourClick: function onColourClick(event) {
      var colour = window.getComputedStyle(event.target, null).getPropertyValue('background-color');
      // Convert rgb(x,x,x) to its hex form
      var m = colour.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      if (m) {
        var rgbObj = {
          r: parseInt(m[1], 10),
          g: parseInt(m[2], 10),
          b: parseInt(m[3], 10)
        };
        colour = Colours.rgb2hex(rgbObj);
      }
      var code = event.target.dataset.code;
      this.ircinput.setColour(code, colour);
      this.$state.setting('fontColor', code);
      this.$state.setting('fontColorColour', colour);
    },
    onResetClick: function onResetClick() {
      this.ircinput.resetStyles();
    },
    onBoldClick: function onBoldClick() {
      var item = document.getElementById('bold');
      var weight = item.style.fontWeight;
      if (Number(weight) > 400 || weight === 'bold' || weight === 'bolder') {
        item.style.fontWeight = 'normal';
        this.$state.setting('boldFont', false);
      } else {
        item.style.fontWeight = 'bold';
        this.$state.setting('boldFont', true);
      }
      this.ircinput.toggleBold();
    },
    onItalicClick: function onItalicClick() {
      var item = document.getElementById('italic');
      var weight = item.style.fontWeight;
      if (Number(weight) > 400 || weight === 'bold' || weight === 'bolder') {
        item.style.fontWeight = 'normal';
        this.$state.setting('italicFont', false);
      } else {
        item.style.fontWeight = 'bold';
        this.$state.setting('italicFont', true);
      }
      this.ircinput.toggleItalic();
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["inputtools"]) window._kiwi_exports["components"]["inputtools"] = {};
window._kiwi_exports["components"]["inputtools"]["TextStyle"]
window._kiwi_exports.components.inputtools.TextStyle = exports.default ? exports.default : exports;
